/** Identificador de sócio da empresa */
export interface SocioIdentificador {
    id: number;
    nome: string;
}

export const identificadorSocioPessoaJuridica: SocioIdentificador = {id: 1, nome: 'Pessoa Jurídica'};
export const identificadorSocioPessoaFisica: SocioIdentificador = {id: 2, nome: 'Pessoa Física'};
export const identificadorSocioEstrangeiro: SocioIdentificador = {id: 3, nome: 'Estrangeiro'};

export const identificadoresSocios: SocioIdentificador[] = [
    identificadorSocioPessoaJuridica,
    identificadorSocioPessoaFisica,
    identificadorSocioEstrangeiro
];

/** Verifica se o identificador do sócio é Pessoa Jurídica */
export function isIdentificadorSocioPessoaJuridica(identificador: number): boolean {
    return identificador === identificadorSocioPessoaJuridica.id;
}

/** Verifica se o identificador do sócio é Pessoa Física */
export function isIdentificadorSocioPessoaFisica(identificador: number): boolean {
    return identificador === identificadorSocioPessoaFisica.id;
}


/** Verifica se o identificador do sócio é Estrangeiro */
export function isIdentificadorSocioEstrangeiro(identificador: number): boolean {
    return identificador === identificadorSocioEstrangeiro.id;
}
